import { KeyValueModel } from "model";
import { EnumFinNFe } from "model/enums/enum-fin-nfe";

export const FinNFeMock: KeyValueModel[] = [
    new KeyValueModel(EnumFinNFe.NORMAL, 'Normal'),
    new KeyValueModel(EnumFinNFe.COMPLEMENTAR, 'Complementar'),
    new KeyValueModel(EnumFinNFe.AJUSTE, 'Ajuste'),
    new KeyValueModel(EnumFinNFe.DEVOLUCAO, 'Mercadoria'),
]